import ActionReducer from 'types/ActionReducer';
import ACTIONS from 'constants/actionTypes';
import { DocLinks } from '../types/Api';

const initialState: {
  docLinks: DocLinks | null;
  canChangeMafStatus: boolean;
} = {
  docLinks: null,
  canChangeMafStatus: true,
};

export const demoStage = (state = initialState, action: ActionReducer) => {
  const { type, payload } = action;
  switch (type) {
    case ACTIONS.SET_DOC_LINKS:
      return { ...state, docLinks: payload as DocLinks };
    case ACTIONS.MAF_STATUS_CHANGE_AVAILABILITY:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default demoStage;
